import BaseService from './BaseService';

class OrderService extends BaseService {
  loadData(criteria, customErrorHandler) {
    return this.get('/api/feed/data', criteria, customErrorHandler);
  }
}

export default OrderService;



// WEBPACK FOOTER //
// ./src/services/OrderService.js